export default __webpack_public_path__ + "static/media/marketing.a9703e43.svg";